import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import '../../../assets/css/custom.css';
import { ChatWidgetV3 } from '../../components/ChatWidget/ChatWidget';
import { AbTest } from '../../common/components/AbTest';

export const ChatWidgetSharedComponent: FunctionComponent = () => {
  const locale = process.env.GATSBY_LOCALE || 'fr';
  const isFR = locale === 'fr';
  const prefix = process.env.GATSBY_ENVIRONMENT == 'production' ? 'prd' : 'dev';

  return (
    <ChatWidgetFormStyle>
      <AbTest campaignId={1362388} variationName="Variation 1">
        {isFR && <ChatWidgetV3 apiUrl={`https://ai-api-${prefix}.exaprint.fr/exabotchat/invoke`} />}
      </AbTest>
    </ChatWidgetFormStyle>
  );
};

const ChatWidgetFormStyle = styled.div`
  position: fixed !important;
  bottom: 180px !important;
  right: 50px !important;
  z-index: 10000 !important;
`;
